var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M15.188 7.874v6.75a1.125 1.125 0 0 1-1.126 1.125H3.938a1.125 1.125 0 0 1-1.126-1.125v-6.75A1.125 1.125 0 0 1 3.939 6.75h1.687a.563.563 0 1 1 0 1.125H3.938v6.75h10.125v-6.75h-1.688a.562.562 0 1 1 0-1.125h1.688a1.125 1.125 0 0 1 1.124 1.125M6.585 4.897l1.853-1.852v6.517a.562.562 0 1 0 1.124 0V3.045l1.853 1.852a.563.563 0 0 0 .796-.796L9.397 1.29a.563.563 0 0 0-.796 0L5.79 4.102a.563.563 0 1 0 .795.795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsShare);
export default __webpack_public_path__ + "static/media/actions-share.fe9e4018462bf10e9bd8e08d1dda2d1a.svg";
export { ForwardRef as ReactComponent };